import { BaseFetch } from "../main-model";
export default class ExportPP4Model extends BaseFetch {
  getExportPP4By = (data) =>
    this.authFetch({
      url: "export-pp4/getExportPP4By",
      method: "POST",
      body: JSON.stringify(data),
    });
}
